module.exports = __webpack_public_path__ + "static/David-2e43b64f6e77a05c79301084febf9afc.png";